import http from '@/lib/http'
import { useMutation } from '@tanstack/react-query'

export default function useGenerateConversationTemplate({
  medRequestId,
  abortController,
  type
}: {
  medRequestId: string
  abortController: AbortController
  type: 'hold' | 'rejection'
}) {
  return useMutation<string, Error, { prompt: string }>({
    mutationFn: ({ prompt }: { prompt: string }) => {
      return http.post(
        `/prescriber/med-requests/${medRequestId}/conversations/generate-template`,
        {
          prescriberPrompt: prompt,
          type
        },
        {
          signal: abortController.signal
        }
      )
    }
  })
}
